export default function install(Vue) {
  Vue.filter('formatNumber', value => {
    const num = Number(value);
    return num.toLocaleString();
  });
}
